<script>
import {mapActions, mapGetters} from "vuex";

export default {
	name: "ShoppingListButton",
	props:{
		product: {
			type: Object,
			required: true
		}
	},
	computed:{
		...mapGetters('shoppingList', ['shoppingListSKUs', 'enabled']),
		...mapGetters(['lang']),
		isInList() {
			return this.shoppingListSKUs.includes(this.product?.sku);
		},
		tooltip() {
			return this.isInList? this.lang?.pdpRemoveFromList: this.lang?.pdpAddToList
		}
	},
	methods: {
		...mapActions('shoppingList', ['addProductToList', 'removeProductFromList']),
		addToList(){
			this.addProductToList(this.product);
		},
		removeFromList(){
			this.removeProductFromList(this.product);
		},
		handleClick(){
			if(this.isInList){
				this.removeFromList();
			} else {
				this.addToList();
			}
		}
	}
}
</script>

<template>
	<div v-if="enabled" class="pdp-btn round shopping-list-btn" :class="`${isInList? 'in-list':''}`" v-tooltip="{content: tooltip, placement: 'bottom'}" @click="handleClick">
		<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 533.33">
			<g>
				<path class="cls-1" d="m33.33,333.33h266.67"/>
				<path class="cls-1" d="m33.33,483.33h266.67"/>
				<path class="cls-1" d="m33.33,183.33h533.33"/>
				<path class="cls-1" d="m33.33,33.33h533.33"/>
				<path class="cls-1 sign" d="m400,416.67h166.67"/>
				<path class="cls-1 sign minus" d="m483.33,333.33v166.67"/>
			</g>
		</svg>
	</div>
</template>

<style scoped lang="scss">
.shopping-list-btn {
  &.in-list{
	background-color: #E95B5B;
	.cls-1{
	  stroke: #FFFFFF;
	  &.sign{
		&.minus {
		  display: none;
		}
	  }
	}
  }

  .cls-1 {
	fill: none;
	stroke: currentColor;
	stroke-linecap: round;
	stroke-linejoin: round;
	stroke-width: 66.67px;
  }

}


</style>
